<template>
  <div class="fromStyle">
    <a-form v-if="editDetail != ''" :form="form" @submit="handleSubmit">
      <a-form-item label="项目" v-bind="formItemLayout">
        <p>{{ editDetail.project_name }}</p>
      </a-form-item>
      <a-form-item label="结算类型" v-bind="formItemLayout">
        <a-radio-group v-model="typeSettlement">
          <a-radio :value="1">保洁模版</a-radio>
        </a-radio-group>
      </a-form-item>
      <div>
        <div class="title">
          <p>甲方/元</p>
          <p>员工/元</p>
        </div>
        <h4>一、双周价格</h4>
        <a-form-item label="单卫" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="double_one_three" />
          <a-input-number :min="0" v-model="double_one_guard" />
        </a-form-item>
        <a-form-item label="双卫 " v-bind="formItemLayout">
          <a-input-number :min="0" v-model="double_two_three" />
          <a-input-number :min="0" v-model="double_two_guard" />
        </a-form-item>
        <a-form-item label="三卫 " v-bind="formItemLayout">
          <a-input-number :min="0" v-model="double_three_three" />
          <a-input-number :min="0" v-model="double_three_guard" />
        </a-form-item>
        <h4>二、退租价格</h4>
        <a-form-item label="单间" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="quit_one_three" />
          <a-input-number :min="0" v-model="quit_one_guard" />
        </a-form-item>
        <a-form-item label="独卫" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="quit_single_three" />
          <a-input-number :min="0" v-model="quit_single_guard" />
        </a-form-item>
        <a-form-item label="公共区域" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="quit_common_three" />
          <a-input-number :min="0" v-model="quit_common_guard" />
        </a-form-item>
        <h4>三、深度价格</h4>
        <a-form-item label="深度" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="depth_three" />
          <a-input-number :min="0" v-model="depth_guard" />
        </a-form-item>
        <h4>四、开荒价格</h4>
        <a-form-item label="1室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_one_three" />
          <a-input-number :min="0" v-model="open_one_guard" />
        </a-form-item>
        <a-form-item label="2室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_two_three" />
          <a-input-number :min="0" v-model="open_two_guard" />
        </a-form-item>
        <a-form-item label="3室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_three_three" />
          <a-input-number :min="0" v-model="open_three_guard" />
        </a-form-item>
        <a-form-item label="4室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_four_three" />
          <a-input-number :min="0" v-model="open_four_guard" />
        </a-form-item>
        <a-form-item label="5室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_five_three" />
          <a-input-number :min="0" v-model="open_five_guard" />
        </a-form-item>
        <a-form-item label="6室" v-bind="formItemLayout">
          <a-input-number :min="0" v-model="open_six_three" />
          <a-input-number :min="0" v-model="open_six_guard" />
        </a-form-item>
      </div>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
import { pcaa } from "area-data";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      proList: [],
      attrList: [],
      typeSettlement: 1,
      double_one_three: "",
      double_one_guard: "",
      double_two_guard: "",
      double_two_three: "",
      double_three_guard: "",
      double_three_three: "",
      quit_one_guard: "",
      quit_one_three: "",
      quit_single_guard: "",
      quit_single_three: "",
      quit_common_guard: "",
      quit_common_three: "",
      depth_guard: "",
      depth_three: "",
      open_one_guard: "",
      open_one_three: "",
      open_two_guard: "",
      open_two_three: "",
      open_three_guard: "",
      open_three_three: "",
      open_four_guard: "",
      open_four_three: "",
      open_five_guard: "",
      open_five_three: "",
      open_six_guard: "",
      open_six_three: ""
    };
  },
  mounted() {},
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.double_one_guard = Number(this.editDetail.double_one_guard);
      this.double_one_three = Number(this.editDetail.double_one_three);
      this.double_two_guard = Number(this.editDetail.double_two_guard);
      this.double_two_three = Number(this.editDetail.double_two_three);
      this.double_three_guard = Number(this.editDetail.double_three_guard);
      this.double_three_three = Number(this.editDetail.double_three_three);
      this.quit_one_guard = Number(this.editDetail.quit_one_guard);
      this.quit_one_three = Number(this.editDetail.quit_one_three);
      this.quit_single_guard = Number(this.editDetail.quit_single_guard);
      this.quit_single_three = Number(this.editDetail.quit_single_three);
      this.quit_common_guard = Number(this.editDetail.quit_common_guard);
      this.quit_common_three = Number(this.editDetail.quit_common_three);
      this.depth_guard = Number(this.editDetail.depth_guard);
      this.depth_three = Number(this.editDetail.depth_three);
      this.open_one_guard = Number(this.editDetail.open_one_guard);
      this.open_one_three = Number(this.editDetail.open_one_three);
      this.open_two_guard = Number(this.editDetail.open_two_guard);
      this.open_two_three = Number(this.editDetail.open_two_three);
      this.open_three_guard = Number(this.editDetail.open_three_guard);
      this.open_three_three = Number(this.editDetail.open_three_three);
      this.open_four_guard = Number(this.editDetail.open_four_guard);
      this.open_four_three = Number(this.editDetail.open_four_three);
      this.open_five_guard = Number(this.editDetail.open_five_guard);
      this.open_five_three = Number(this.editDetail.open_five_three);
      this.open_six_guard = Number(this.editDetail.open_six_guard);
      this.open_six_three = Number(this.editDetail.open_six_three);
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(attr_config);
      this.form.validateFields((err, value) => {
        //   console.log(pramas)
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.clean +
            "Account_config/editAccountConfig";
          let params = {
            id: this.editDetail.id,
            type: this.typeSettlement,
            token: window.localStorage.getItem("xnwfPcToken"),
            double_one_guard: this.double_one_guard,
            double_one_three: this.double_one_three,
            double_two_guard: this.double_two_guard,
            double_two_three: this.double_two_three,
            double_three_guard: this.double_three_guard,
            double_three_three: this.double_three_three,
            quit_one_guard: this.quit_one_guard,
            quit_one_three: this.quit_one_three,
            quit_single_guard: this.quit_single_guard,
            quit_single_three: this.quit_single_three,
            quit_common_guard: this.quit_common_guard,
            quit_common_three: this.quit_common_three,
            depth_guard: this.depth_guard,
            depth_three: this.depth_three,
            open_one_guard: this.open_one_guard,
            open_one_three: this.open_one_three,
            open_two_guard: this.open_two_guard,
            open_two_three: this.open_two_three,
            open_three_guard: this.open_three_guard,
            open_three_three: this.open_three_three,
            open_four_guard: this.open_four_guard,
            open_four_three: this.open_four_three,
            open_five_guard: this.open_five_guard,
            open_five_three: this.open_five_three,
            open_six_guard: this.open_six_guard,
            open_six_three: this.open_six_three
          };
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 30px 4% 0;
  padding-bottom: 30px;
  h3 {
    margin: 30px 4% 40px;
    // width: 25%;
    // text-align: right;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 24%;
    margin-top: 30px;
    p {
      width: 90px;
      margin-right: 40px;
    }
  }
  h4 {
    width: 20.84%;
    text-align: right;
    margin: 20px 0 10px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-input-number {
    margin-right: 30px;
  }
  .yuan {
    font-style: normal;
    font-size: 12px;
    display: inline-block;
    margin-right: 4px;
    color: #999;
  }
}
</style>

<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
